var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53461 5.82226L4.5 1.49998C4.5 1.49998 6.48754 0.367408 8.79257 1.48067C8.79257 1.48067 10.3021 2.1063 12.2104 1.35152C12.2104 1.35152 13.9367 0.501 15.5 1.5L14 5.82186L6.53461 5.82226Z",
    stroke: "currentColor",
    strokeWidth: 1.35714,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53455 5.82202C6.53455 5.82202 2.0032 9.49048 2 15.4579C1.99894 17.4648 2.99996 18.5 4.28997 18.945C4.46196 18.9393 5.19575 18.9763 5.38051 18.9627C5.54505 18.9502 5.71064 18.9442 5.87624 18.945L15.8024 18.9977C15.8024 18.9977 17.9792 19.1476 18 15.5C18.0025 15.0635 18 15 18 15C18 15 18.5 9.50003 13.862 5.82202",
    stroke: "currentColor",
    strokeWidth: 1.35714,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0694 10.1438H9.62061C9.20582 10.1438 8.79529 10.2303 8.45132 10.4057C8.09883 10.5852 7.76711 10.8756 7.78042 11.3311C7.79533 11.8561 8.28359 12.3051 8.95343 12.4435C9.40017 12.5357 9.98215 12.621 10.5466 12.6001C11.3879 12.5691 12.1344 13.0193 12.2291 13.6518C12.2323 13.6723 12.235 13.6932 12.2371 13.7145C12.2952 14.271 11.7457 14.8093 11.0119 14.8733C10.2745 14.9376 9.21008 14.899 8.01204 14.8733",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 9.14148V9.50002",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L10.0099 16.0181",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.b0adf9ad.svg";
export { ForwardRef as ReactComponent };